import { useState, useCallback, useEffect } from 'react';
import { Account } from '@/types';
import { toast } from 'sonner';

const ACCOUNTS_STORAGE_KEY = 'glmt-accounts';

export const useAccounts = () => {
  const [accounts, setAccounts] = useState<Account[]>(() => {
    const stored = localStorage.getItem(ACCOUNTS_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem(ACCOUNTS_STORAGE_KEY, JSON.stringify(accounts));
  }, [accounts]);

  const handleFileUpload = (data: any[]) => {
    const newAccounts = data.map((row, index) => {
      const account: Account = {
        id: `acc-${Date.now()}-${index}`,
        number: row.number?.toString() || '',
        description: row.description || '',
        type: row.type === 'Afdracht' ? 'Afdracht' : 'Geen afdracht',
      };
      return account;
    });

    setAccounts(prevAccounts => {
      const existingAccountMap = new Map(
        prevAccounts.map(acc => [acc.number, acc])
      );
      
      newAccounts.forEach(acc => {
        existingAccountMap.set(acc.number, acc);
      });
      
      return Array.from(existingAccountMap.values());
    });
    
    console.log('Updated accounts:', accounts);
  };

  const addAccount = useCallback((account: Account) => {
    setAccounts(prev => {
      const newAccounts = [...prev, account];
      return newAccounts.sort((a, b) => {
        const numA = parseInt(a.number) || 0;
        const numB = parseInt(b.number) || 0;
        return numA - numB;
      });
    });
  }, []);

  const removeAccount = useCallback((accountId: string) => {
    setAccounts(prev => prev.filter(acc => acc.id !== accountId));
  }, []);

  return {
    accounts,
    handleFileUpload,
    addAccount,
    removeAccount,
    setAccounts,
  };
};

